export default "__VITE_ASSET__CM4yIS0Z__"